@import "../../global/normalize.css";

:host {
  display: block;
  border-bottom: var(--ic-space-1px) solid var(--ic-accordion-divider);
}

:host .expand-chevron {
  color: var(--ic-accordion-chevron);
}

:host(.ic-accordion-disabled) .expand-chevron {
  color: var(--ic-accordion-chevron-disabled);
}

.section-button.small {
  padding: var(--ic-space-xxs) var(--ic-space-xs);
}

.section-button.large {
  padding: var(--ic-space-sm) var(--ic-space-xs);
}

:host(:first-of-type) {
  border-top: var(--ic-space-1px) solid var(--ic-accordion-divider);
}

:focus {
  outline: none;
}

.section-button {
  background-color: transparent;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--ic-space-xs);
  font-weight: var(--ic-font-weight-bold);
  border: none;
}

.section-header {
  --ic-typography-color: var(--ic-accordion-heading-text);

  color: var(--ic-accordion-heading-text);
  text-align: left;
  flex: 1 0;
}

:host(.ic-accordion-disabled) .section-header {
  --ic-typography-color: var(--ic-accordion-heading-text-disabled);

  color: var(--ic-accordion-heading-text-disabled);
}

button:hover {
  background-color: var(--ic-accordion-background-hover);
  cursor: pointer;
}

button:active {
  background-color: var(--ic-accordion-background-pressed);
}

button:focus {
  box-shadow: var(--ic-border-focus);
  border-radius: var(--ic-border-radius);
  transition: var(--ic-transition-duration-fast);
}

button:disabled {
  pointer-events: none;
}

.icon-container {
  margin: 0 var(--ic-space-xs) 0 0;
  display: flex;
  align-items: center;
  width: var(--ic-space-lg);
  height: var(--ic-space-lg);
  color: var(--ic-accordion-icon);
}

:host(.ic-accordion-disabled) .icon-container {
  color: var(--ic-accordion-icon-disabled);
}

::slotted(svg) {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
}

.expand-chevron {
  width: var(--ic-space-lg);
  height: var(--ic-space-lg);
  margin-left: calc(var(--ic-space-xl) + var(--ic-space-xs));
  transform: rotate(90deg);
  justify-self: end;
}

.content-expanded-chevron {
  transform: rotate(-90deg);
}

.expanded-content {
  --ic-typography-color: var(--ic-accordion-body-text);

  color: var(--ic-accordion-body-text);
  height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  visibility: var(--ic-expanded-content-visibility, hidden);
}

.expanded-content-inner {
  padding: var(--ic-space-xs);
}

.expanded-content-opened {
  overflow: visible;
}

@media (forced-colors: active) {
  button:focus {
    border: var(--ic-border-hc) !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  button:focus {
    transition: none;
  }
}
